import { styled } from '@mui/material/styles';
export const DateTimeViewWrapper = styled('div')({
  display: 'flex',
  margin: '0 auto'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/x-date-pickers/internals/components/DateTimeViewWrapper/DateTimeViewWrapper.js
// module id = 13229
// module chunks = 0